import { render, staticRenderFns } from "./FieldsetFavoriteTeamParts.vue?vue&type=template&id=5692891c&scoped=true"
import script from "./FieldsetFavoriteTeamParts.vue?vue&type=script&lang=ts"
export * from "./FieldsetFavoriteTeamParts.vue?vue&type=script&lang=ts"
import style0 from "./FieldsetFavoriteTeamParts.vue?vue&type=style&index=0&id=5692891c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5692891c",
  null
  
)

export default component.exports